import styled from "styled-components";

export const WxdhPopupSyle = styled.div`

    @font-face {
      font-family: 'dingliesongtypeface';
      src: url('https://cdn-prd.ggac.com/ggac/font/dingliesongtypeface20241217.ttf');
    }
    @font-face {
        font-family: 'SourceHanSerifCN';
        src: url('https://cdn-prd.ggac.com/ggac/font/SourceHanSerifCN-Medium.otf');
    }

    .top {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    .flower {
        position: absolute;
        right: -70px;
        bottom: 45px;
    }

    .close-wrap {
        position: absolute;
        right: 50px;
        top: 35px;
        img {
            cursor: pointer;
        }
    }

    .popup-title {
        font-size: 26px;
	    color: #fdf4da;
        font-family: 'dingliesongtypeface';
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 30px;
        margin: 25px 0 50px;
        img {
            width: 116px;
        }
    }

    
    .content-wrap {
        padding: 0 120px;
        .content {
            padding-right: 60px;
            position: relative;
            font-family: 'dingliesongtypeface';
            height: 400px;
            overflow: auto;
            position: relative;
            .close {
                width: 30px;
                cursor: pointer;
            }

            ::-webkit-scrollbar {
                width: 6px; /* 设置滚动条的宽度 */
                background-color: transparent; /* 滚动条的背景色 */
            }
            ::-webkit-scrollbar-track {
              background: #8d8ffc; /* 轨道的背景色 */
              border-radius: 10px; /* 轨道的圆角 */
            }
            /* 自定义滚动条的滑块（thumb） */
            ::-webkit-scrollbar-thumb {
              background-color: #ffedb4; /* 滑块的背景色 */
              border-radius: 10px; /* 滑块的圆角 */
            }
        }

        .date {
            font-size: 20px;
	        line-height: 34px;
	        color: #ffe79a;
            text-align: center;
            span {
                font-weight: bold;
            }
        }
    }

    .sub-title {
        gap: 30px;
        font-size: 30px;
	    color: #fdf4da;
        position: relative;
        margin: 30px 0;
        text-align: center;
        &::after {
            content: "";
            width: 396px;
            height: 15px;
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-popup-sub-title-bottom.png") center center no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -12px;
        }
        img {
            width: 19px;
            height: 18px;
        }
    }

    .tip {
        font-size: 20px;
        line-height: 32px;
        color: #ffe79a;
        text-align: center;
        span {
            font-weight: bold;
        }
    }

    .word {
        font-size: 20px;
        div {
	        line-height: 35px;
	        color: #fff;
            text-align: center;
        }
        span {
            font-weight: bold;
        }
    }

    

    .btn {
        height: 61px;
        aspect-ratio: 288 / 61;
        background: url(https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-popup-btn.png) center center / 100% 100% no-repeat;
        font-size: 31px;
        color: #f2fbff;
        display: flex;
        align-items: center;
        margin: 30px auto 0;
        justify-content: center;
        cursor: pointer;
        padding-bottom: 3px;
        div {
            background: linear-gradient(0deg, #262764 0%, #1e153d 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .tip2 {
        font-size: 18px;
	    letter-spacing: 2px;
        color: #ffe79a;
        text-align: center;
        margin-top: 10px;
    }

    .tip3 {
        font-size: 16px;
        color: #ffe79a;
        text-align: center;
        margin-top: 10px;
        span {
            font-weight: bold;
        }
    }
`